import * as yup from 'yup';
import { z } from 'zod';

export const zipSchema = yup
  .string()
  .required('Postal code is required')
  .matches(/^\d{5}$/, 'Please enter a valid 5-digit ZIP code');

// TODO replace with zod schema once we remove GPOC
export const addressSchema = yup.object({
  address: yup.string().required(),
  city: yup.string(),
  coords: yup.object({
    lat: yup.number().required(),
    lng: yup.number().required(),
  }),
  country: yup.string(),
  county: yup.string(),
  place_id: yup.string(),
  source: yup.string().oneOf(['ip', 'zip', 'address']).default(undefined),
  state: yup.string(),
  state_code: yup.string(),
  street: yup.string().required('Street address is required'),
  utc_offset: yup.number(),
  zip: zipSchema,
});

export type Address = yup.InferType<typeof addressSchema>;

export const geolocationSchema = z.object({
  address: z.string(),
  city: z.string().optional(),
  coords: z.object({ lat: z.number(), lng: z.number() }),
  country: z.string(),
  county: z.string().optional(),
  source: z.enum(['ip', 'zip', 'address']),
  state: z.string().optional(),
  state_code: z.string(),
  street: z.string().optional(),
  utc_offset: z.number().optional(),
  zip: z.string().optional(),
});

export type Geolocation = z.infer<typeof geolocationSchema>;

// place_id isn't always set, so street+zip (both required) is the reliable identity check.
export const isSameAddress = (a?: Address, b?: Address) => !!a && !!b && a.street === b.street && a.zip === b.zip;

export const formatAddress = (address?: Address) => {
  if (!address?.street) {
    return '';
  }
  return address.address || [address.street, address.city, address.state_code, address.zip].filter(Boolean).join(', ');
};
